module.exports = __webpack_public_path__ + "img/diaohua3.b3712c5c.jpg";